import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/site/Navbar';
import { Footer } from './components/site/Footer';
import { ScrollToTop } from './components/site/ScrollToTop';
import { Home } from './pages/Home';
import { ParaVoce } from './pages/ParaVoce';
import { ParaNegocio } from './pages/ParaNegocio';
import { ParaMarca } from './pages/ParaMarca';
import { ODS } from './pages/ODS';
import { BairrouEduca } from './pages/BairrouEduca';
import { BairrouGov } from './pages/BairrouGov';
import { BairrouClube } from './pages/BairrouClube';
import { TropaDoBairrou } from './pages/TropaDoBairrou';
import { Contato } from './pages/Contato';
import { ParaOng } from './pages/ParaOng';
import { ParaInvestidor } from './pages/ParaInvestidor';
import { LanguageProvider } from './components/site/i18n';
import { ThemeProvider } from './components/site/ThemeProvider';
export function App() {
  return <ThemeProvider data-id="element-0" data-mp="23v2u55stx56g">
      <LanguageProvider data-id="element-1" data-mp="3ijxpqrsp22kf">
        <Router data-id="element-2" data-mp="3ikh5c1uvgeva">
          <ScrollToTop data-id="element-3" data-mp="3iiwg8rrbto4t" />
          <div className="flex flex-col min-h-screen font-sans selection:bg-brand-yellow selection:text-brand-charcoal text-brand-charcoal bg-brand-cream dark:bg-gray-900 dark:text-gray-100 transition-colors duration-300" data-id="element-4" data-mp="3ijpc2xoqyt86">
            <Navbar data-id="element-5" data-mp="3relwynhtxubv" />
            <main className="flex-grow" data-id="element-6" data-mp="6hqffdy0fe4">
              <Routes data-id="element-7" data-mp="5ggje8nxyxz">
                <Route path="/" element={<Home data-id="element-9" data-mp="2zld2xbxu5jcl" />} data-id="element-8" data-mp="82ohezguggq" />
                <Route path="/para-voce" element={<ParaVoce data-id="element-11" data-mp="2zmwh8wzxlkbq" />} data-id="element-10" data-mp="2zm4zaoz9bl3x" />
                <Route path="/para-negocio" element={<ParaNegocio data-id="element-13" data-mp="33nq55qddiz4m" />} data-id="element-12" data-mp="33mf2xuzktzfm" />
                <Route path="/para-marca" element={<ParaMarca data-id="element-15" data-mp="38m1jadapbvsn" />} data-id="element-14" data-mp="33orik1hv3xpi" />
                <Route path="/ods" element={<ODS data-id="element-17" data-mp="38nuorp9kw9z2" />} data-id="element-16" data-mp="38l053zye2t6p" />
                <Route path="/educa" element={<BairrouEduca data-id="element-19" data-mp="3dl4jnkfqldua" />} data-id="element-18" data-mp="3dkus3sf1mymh" />
                <Route path="/gov" element={<BairrouGov data-id="element-21" data-mp="nvj5hlha6osd" />} data-id="element-20" data-mp="3dm60k5jfoujx" />
                <Route path="/clube" element={<BairrouClube data-id="element-23" data-mp="nv1284w7baay" />} data-id="element-22" data-mp="nwc5m3lqig1j" />
                <Route path="/tropa" element={<TropaDoBairrou data-id="element-25" data-mp="stuczpk3sn7f" />} data-id="element-24" data-mp="sunadzx6a0cw" />
                <Route path="/ongs" element={<ParaOng data-id="element-27" data-mp="36hx792iaw2a" />} data-id="element-26" data-mp="sssrer5goibg" />
                <Route path="/investidores" element={<ParaInvestidor data-id="element-29" data-mp="34nb3rfi0xwm" />} data-id="element-28" data-mp="35oxgs1yt6tn" />
                <Route path="/contato" element={<Contato data-id="element-31" data-mp="3ubrgkhvzwc2x" />} data-id="element-30" data-mp="3ud1gzdqblwcq" />
              </Routes>
            </main>
            <Footer data-id="element-32" data-mp="d4e4tqw8j8vn" />
          </div>
        </Router>
      </LanguageProvider>
    </ThemeProvider>;
}